import { render } from "./AssessementScore.vue?vue&type=template&id=d194b30c"
import script from "./AssessementScore.vue?vue&type=script&lang=js"
export * from "./AssessementScore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__